import { jsx, jsxs, Fragment as Fragment$1 } from "react/jsx-runtime";
import { useBreadcrumbs, useBreadcrumbItem } from "@react-aria/breadcrumbs";
import { useState, Fragment, useRef } from "react";
import "../ThemeProvider/ThemeProvider.mjs";
import "../ThemePortal/ThemePortal.mjs";
import "../Text/TextContext.mjs";
import "../ThemeProvider/ThemeContext.mjs";
import "../ThemeProvider/VanillaThemeContainer.mjs";
import "../private/DefaultMessagesContext.mjs";
import "../ThemeProvider/BreakpointContext.mjs";
import "../../css/atoms/sprinkles.css.mjs";
import { PublicBox } from "../Box/Box.mjs";
import "../Box/BackgroundContext.mjs";
import "../Divider/Divider.css.mjs";
import "../Heading/HeadingContext.mjs";
import "../Hidden/Hidden.css.mjs";
import "../../css/negativeMargin/negativeMargin.css.mjs";
import "../Accordion/AccordionContext.mjs";
import { Text } from "../Text/Text.mjs";
import "../Columns/ColumnsContext.mjs";
import "../Column/Column.css.mjs";
import { Inline } from "../Inline/Inline.mjs";
import "../../css/lineHeightContainer.css.mjs";
import "../../css/reset/reset.css.mjs";
import "../../hooks/useIcon/icon.css.mjs";
import "../../css/typography.css.mjs";
import { IconChevronRight } from "../icons/IconChevronRight/IconChevronRight.mjs";
import { IconMoreHoriz } from "../icons/IconMoreHoriz/IconMoreHoriz.mjs";
import "../private/touchable/virtualTouchable.css.mjs";
import "../private/hideFocusRings/hideFocusRings.css.mjs";
import "../Accordion/AccordionItem.css.mjs";
import "../Actions/ActionsContext.mjs";
import "../../css/textAlignedToIcon.css.mjs";
import "../Alert/Alert.css.mjs";
import "../Autosuggest/Autosuggest.mjs";
import "../Avatar/Avatar.css.mjs";
import "../Badge/Badge.mjs";
import { iconContainer, itemContainer, item } from "./Breadcrumb.css.mjs";
import "../Box/ColoredBox.mjs";
import "../Button/Button.mjs";
import "../ButtonIcon/ButtonIcon.mjs";
import "../ButtonLink/ButtonLink.mjs";
import "../private/Keyline/Keyline.css.mjs";
import "../Checkbox/Checkbox.mjs";
import "../Checkbox/CheckboxStandalone.mjs";
import "../ContentBlock/ContentBlock.css.mjs";
import "../DateField/DateField.mjs";
import "../private/Field/FloatingLabel.css.mjs";
import "../private/Field/Field.css.mjs";
import "../DateField/DateField.css.mjs";
import "../private/Modal/Modal.mjs";
import "../private/Modal/ModalContent.mjs";
import "../private/Modal/ModalContext.mjs";
import "../TextLink/TextLink.mjs";
import "../TextLinkButton/TextLinkButton.css.mjs";
import "../private/AvoidWidowIcon/AvoidWidowIcon.css.mjs";
import "../Dropdown/Dropdown.mjs";
import "../private/MaxLines/MaxLines.css.mjs";
import "../HiddenVisually/HiddenVisually.css.mjs";
import { Link } from "../Link/Link.mjs";
import "../private/defaultTextProps.mjs";
import "../List/List.css.mjs";
import "../Loader/Loader.css.mjs";
import "../Skeleton/Skeleton.css.mjs";
import "../MenuRenderer/MenuRenderer.mjs";
import "../MenuItem/MenuItem.mjs";
import "../MenuItemCheckbox/MenuItemCheckbox.mjs";
import "../MenuItemDivider/MenuItemDivider.mjs";
import "../MenuItem/MenuItemLink.mjs";
import "../OverflowMenu/OverflowMenu.css.mjs";
import "../MonthPicker/MonthPicker.mjs";
import "../Pagination/Pagination.css.mjs";
import "../PasswordField/PasswordField.mjs";
import "../Pincode/Pincode.mjs";
import "../PopoverRenderer/PopoverRenderer.mjs";
import "../Pressable/Pressable.mjs";
import "../RadioGroup/RadioGroup.mjs";
import "../RadioGroup/RadioItem.mjs";
import "../RadioGroup/RadioItemBlock.mjs";
import { ResponsiveRender } from "../ResponsiveRender/ResponsiveRender.mjs";
import "../SelectableList/SelectableList.css.mjs";
import "../private/BulkActions/BulkActions.css.mjs";
import "../Spread/Spread.css.mjs";
import "../Stepper/Step.mjs";
import "../Stepper/Stepper.mjs";
import "../Tabs/Tab.mjs";
import "../Table/Table.mjs";
import "../Table/Table.css.mjs";
import "../Tabs/TabsProvider.mjs";
import "../Tabs/TabListContext.mjs";
import "../Tabs/Tabs.css.mjs";
import "../Tabs/TabPanelsContext.mjs";
import "../Tag/Tag.css.mjs";
import "../Textarea/Textarea.mjs";
import "../TextDropdown/TextDropdown.css.mjs";
import "../TextField/TextField.mjs";
import "../Tiles/Tiles.css.mjs";
import "../Toggle/Toggle.mjs";
import "../useToast/ToastContext.mjs";
import { TooltipRenderer } from "../TooltipRenderer/TooltipRenderer.mjs";
import "../TimeField/DateSegment.css.mjs";
import "../private/FieldButtonIcon/FieldButtonIcon.mjs";
import "../MultiStepModal/MultiStepModal.mjs";
import "../SearchField/SearchField.mjs";
import "../RadioBar/RadioBarContext.mjs";
import "../RadioBar/RadioBar.css.mjs";
import "../../themes/vars.css.mjs";
import "../RadioBar/RadioBar.mjs";
const MAX_ITEMS = 4;
const BreadcrumbText = ({ isCurrent, label, href, ...itemProps }) => /* @__PURE__ */ jsx(Text, { ...itemProps, weight: "regular", tone: "neutral", maxLines: 1, children: href && !isCurrent ? /* @__PURE__ */ jsx(Link, { href, className: item, children: label }) : label });
const IconSeparator = () => /* @__PURE__ */ jsx(PublicBox, { as: "span", "aria-hidden": "true", children: /* @__PURE__ */ jsx(IconChevronRight, { tone: "secondary", size: "xsmall" }) });
const LineSeparator = () => /* @__PURE__ */ jsx(PublicBox, { as: "span", "aria-hidden": "true", children: "/" });
function BreadcrumbItem({ isCurrent, label, href = "" }) {
  const ref = useRef(null);
  const { itemProps } = useBreadcrumbItem({ children: label, isCurrent, elementType: "div" }, ref);
  return /* @__PURE__ */ jsxs(PublicBox, { as: "li", ref, display: "flex", children: [
    /* @__PURE__ */ jsx(ResponsiveRender, { below: "tablet", children: /* @__PURE__ */ jsx(PublicBox, { className: itemContainer, children: /* @__PURE__ */ jsx(BreadcrumbText, { ...itemProps, isCurrent, label, href }) }) }),
    /* @__PURE__ */ jsx(ResponsiveRender, { above: "mobile", children: /* @__PURE__ */ jsx(TooltipRenderer, { id: `${label}-tooltip`, tooltip: /* @__PURE__ */ jsx(Text, { children: label }), children: ({ triggerProps: { ref: triggerRef, ...triggerProps } }) => /* @__PURE__ */ jsx(
      PublicBox,
      {
        ref: (node) => {
          triggerRef(node);
        },
        ...triggerProps,
        className: itemContainer,
        children: /* @__PURE__ */ jsx(BreadcrumbText, { ...itemProps, isCurrent, label, href })
      }
    ) }) })
  ] });
}
const Breadcrumb = ({ items, variant = "default" }) => {
  const truncateItems = items.length > MAX_ITEMS;
  const [showItems, setShowItems] = useState(!truncateItems);
  const separator = variant === "line" ? /* @__PURE__ */ jsx(LineSeparator, {}) : /* @__PURE__ */ jsx(IconSeparator, {});
  const { navProps } = useBreadcrumbs({});
  const handleClickMore = () => setShowItems(true);
  return /* @__PURE__ */ jsx(PublicBox, { as: "nav", ...navProps, color: void 0, children: /* @__PURE__ */ jsx(PublicBox, { as: "ol", children: /* @__PURE__ */ jsx(Inline, { space: "xxsmall", alignY: "center", children: showItems ? items.map((item2, idx) => {
    const isCurrent = idx === items.length - 1;
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(BreadcrumbItem, { isCurrent, ...item2 }),
      !isCurrent && separator
    ] }, idx);
  }) : /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx(BreadcrumbItem, { isCurrent: false, ...items == null ? void 0 : items[0] }),
    separator,
    /* @__PURE__ */ jsx(PublicBox, { className: iconContainer, onClick: handleClickMore, role: "button", children: /* @__PURE__ */ jsx(IconMoreHoriz, {}) }),
    separator,
    /* @__PURE__ */ jsx(BreadcrumbItem, { isCurrent: true, ...items == null ? void 0 : items[items.length - 1] })
  ] }) }) }) });
};
export {
  Breadcrumb
};
